import { useMutation, useQueryClient } from 'react-query';

import { singVisitByPestEmployeePostDigest as sing } from 'api/digestReports/signVisitByPestEmployeeDigest';

const useSignVisitByEmployeeDigest = () => {
  const queryClient = useQueryClient();

  const {
    isSuccess,
    mutate: singVisitByEmployee,
    isLoading,
  } = useMutation(sing, {
    onSuccess: () => {
      queryClient.invalidateQueries('digestDocs');
    },
  });

  return {
    isSuccess,
    singVisitByEmployee,
    isLoading,
  };
};

export default useSignVisitByEmployeeDigest;
